import { connect } from 'react-redux';

import type { HeaderCopyBlockProps } from 'src/components/organisms/HeaderCopyBlock/HeaderCopyBlock';
import { HeaderCopyBlock } from 'src/components/organisms/HeaderCopyBlock/HeaderCopyBlock';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import trackSEOCopyLinkClick from 'src/tracking/events/SEOCopyLinkClick';
import { trackSEOCopyToggle } from 'src/tracking/events/seoCopyToggle';

const mapStateToProps = ({ content, products }: ReduxApplicationState): HeaderCopyBlockProps => {
  const heading = content.category!.heading;

  return {
    description: products.initialProductPage === 1 ? content.category!.description : undefined,
    heading,
    subheading: content.category!.subheading,
    onAccordionToggle: ({ open }) => {
      trackSEOCopyToggle({ open, heading });
    },
    onDescriptionLinkClick: trackSEOCopyLinkClick,
  };
};

export const HeaderCopyBlockContainer = connect(mapStateToProps)(HeaderCopyBlock);
